import React from 'react'
import ReactIframe from 'react-iframe'

export const Newsletter = () => (
  <section className="container flex mx-auto">
    <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
      <div className="space-y-1 md:max-w-3/4 text-night">
        <p className="font-semibold">Rejoignez la communauté</p>
        <p>
          Découvrez chaque mois les bonnes pratiques en cabinet et de nouvelles
          opportunités
        </p>
      </div>

      <div className="space-y-4">
        <ReactIframe
          url="https://lamacompta.substack.com/embed"
          width="100%"
          styles={{
            border: '1px solid #C1DBFE',
            borderRadius: '10px',
          }}
        />
        {/* <form className="flex items-center justify-end space-x-2 md:space-x-4 lg:space-x-6 max-w-3/4">
            <input
              type="email"
              placeholder="Entrez votre email"
              className="w-full px-4 py-4 text-sm bg-transparent border rounded-full shadow-sm border-night text-night focus:outline-none focus:ring-night focus:border-night sm:text-base placeholder:text-night"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <button
              type="submit"
              disabled={!email}
              className="px-4 py-4 text-sm border rounded-full border-night text-night sm:text-base focus:outline-none focus:ring-offset-2 focus:ring-offset-night disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Je&nbsp;m&apos;inscris
            </button>
          </form>
          <p className="text-sm font-thin text-night">En vous abonnant, vous acceptez notre Politique de confidentialité.</p> */}
      </div>
    </div>
  </section>
)
